<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    id="champion_picker"
    style="margin-top: 12px"
    v-if="selectedOption"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t(`calculators_common.${currentGameSlug}.preferredChamps`) }}
    </h4>

    <div class="champions_box d-flex-column justify-start align-start">
      <div class="d-flex-row justify-start champion_search">
        <SearchOutlinedIcon />
        <input
          type="text"
          v-model="searchQuery"
          class="champion_search_input"
          placeholder="Search Champion"
        />
      </div>
      <!-- <div class="champion_grid_container" style="margin-top: 10px"> -->
      <TransitionGroup
        name="list"
        tag="div"
        class="champion_grid_container"
        style="margin-top: 10px"
        id="champions_grid"
      >
        <button
          class="champ_button"
          v-for="gameHero in filteredChamps"
          :key="gameHero"
          @click="() => selectChampion(gameHero.id)"
          :class="[isSelected(gameHero.id) && 'selected']"
        >
          <div class="champ_image_container">
            <img
              :src="gameHero.image"
              class="champion_img"
              alt="Gmae character image"
              loading="lazy"
            />
          </div>
          <h4 class="t-white medium-s font-family-2">
            {{ gameHero.title }}
          </h4>
        </button>
      </TransitionGroup>
      <!-- 
      <p
        class="t-danger bold-m f-w-500 font-family-2 mt-2"
        v-if="getCartErrors['champions_error']"
      >
        *{{ getCartErrors["champions_error"] }}
      </p> -->
    </div>
  </div>
</template>

<script setup>
import SearchOutlinedIcon from "~/components/icons/SearchOutlinedIcon.vue";
import { ref, computed, watch } from "vue";
const gameStore = useGameStore();

const checkoutStore = useCheckoutStore();
const { apiGetGameHeroes } = useGameStore();
const { currentGameSlug } = useGameComposable();
const props = defineProps({
  selectOnlyOneChampion: {
    default: false,
  },
  showAlways: {
    default: false,
  },
});

const searchQuery = ref("");

const filteredChamps = computed(() => {
  return gameStore.getGameHeroes
    .filter((champ) =>
      champ.title.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
    .sort((a, b) => a.title.localeCompare(b.title));
});

const selectedOption = computed(() => {
  if (
    gameStore.getGamePack.slug === "league-of-legends-mastery-boost" ||
    gameStore.getGamePack.slug === "dota-2-win-rate-boosting"
  ) {
    return true;
  }
  const options = gameStore.getGamePack.pack_options;
  const selectedOptions = options.filter((option) =>
    checkoutStore.getPackOptions.includes(option.id)
  );
  const isSpecChampionSelected = selectedOptions.findIndex(
    (option) =>
      [
        "Spec Champions",
        "Agents Preferences",
        "Specific Operators",
        "Specific Heroes",
        "Specific Champions",
        "Specific Agents",
        "Roles Preferences",
        "Specific Heroes & Roles",
        "Specific Legends",
        "Champions Preferences",
        "preferred_heroes",
      ].includes(option.title) ||
      [
        "Spec Champions",
        "Agents Preferences",
        "Specific Operators",
        "Specific Heroes",
        "Specific Champions",
        "Specific Agents",
        "Roles Preferences",
        "Specific Heroes & Roles",
        "Specific Legends",
        "Champions Preferences",
        "preferred_heroes",
      ].includes(option.const_title)
  );
  return isSpecChampionSelected >= 0;
});

const selectChampion = (championId) => {
  if (!props.selectOnlyOneChampion) {
    checkoutStore.setHero({
      championId,
    });
  } else {
    checkoutStore.setOneHero({
      championId,
    });
  }
};
const isSelected = (champion) => {
  return checkoutStore.getSelectedHeros.includes(champion);
};

watch(selectedOption, (newVal) => {
  if (newVal) {
    apiGetGameHeroes({
      gameSlug: currentGameSlug,
    });
  }
});

watch(filteredChamps, (newVal) => {
  if (document?.getElementById) {
    const element = document?.getElementById("champions_grid");
    if (element) {
      element.scrollTop = 0;
    }
  }
});
</script>
